import { writable } from "svelte/store";
import { get as getStoreValue } from "svelte/store";

interface ProductLineNavigationStoreContents {
  preSelectedContainerType: string | null;
  preSelectedVintage: number | string | null;
}

const defaultStoreState: ProductLineNavigationStoreContents = {
  preSelectedContainerType: null,
  preSelectedVintage: null,
};

export const ProductLineNavigationStore = writable(defaultStoreState);

const resetProductLineNavigationStore = () => {
  ProductLineNavigationStore.set(defaultStoreState);
};

export const getPreselectedProductAttributes = () => {
  const store = getStoreValue(ProductLineNavigationStore);
  resetProductLineNavigationStore();
  return store;
};
